import { Search } from 'lucide-react';
import { Input } from '../ui/Input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import type { CaseStatus } from '../../types';
import { CASE_STATUS_CONFIG } from '../../types';

interface CaseFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: CaseStatus | 'all';
  onStatusChange: (value: CaseStatus | 'all') => void;
  owner: string;
  onOwnerChange: (value: string) => void;
  owners: string[];
}

export function CaseFilters({
  search,
  onSearchChange,
  status,
  onStatusChange,
  owner,
  onOwnerChange,
  owners,
}: CaseFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[200px] max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Search cases..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>
      <Select
        value={status}
        onValueChange={(value: string) => onStatusChange(value as CaseStatus | 'all')}
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="All Statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          {(Object.keys(CASE_STATUS_CONFIG) as CaseStatus[]).map((statusKey) => (
            <SelectItem key={statusKey} value={statusKey}>
              {CASE_STATUS_CONFIG[statusKey].label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={owner || 'all'}
        onValueChange={(value: string) => onOwnerChange(value === 'all' ? '' : value)}
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="All Owners" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Owners</SelectItem>
          {owners.map((ownerName) => (
            <SelectItem key={ownerName} value={ownerName}>
              {ownerName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
